// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card[data-v-51def7ec] {\n  border: 1px solid #dddee1;\n  border-color: #e9eaec;\n  background: #fff;\n  border-radius: 4px;\n  font-size: 14px;\n  position: relative;\n}\n.card[data-v-51def7ec] {\n  border-radius: 0;\n}\n.card .header[data-v-51def7ec] {\n  background-color: #f7f7f7;\n  padding: 10px 10px;\n  font-weight: 900;\n  font-size: 14px;\n}\n.card .body[data-v-51def7ec] {\n  padding: 10px 20px;\n}", ""]);
// Exports
module.exports = exports;
